import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

export default function Watermark() {
  const { user } = useAuth();
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!user) return null;
  const company = user.company_name ? `${user.company_name} · ` : "";
  const label = `${company}${user.name} · ${user.phone || ""} · ${now.toLocaleString("vi-VN")}`;
  const tiles = Array.from({ length: 80 });

  return (
    <div
      aria-hidden
      data-testid="watermark"
      className="fixed inset-0 z-[9998] pointer-events-none overflow-hidden select-none"
    >
      <div
        className="absolute -inset-1/2 flex flex-wrap content-start gap-x-16 gap-y-16 opacity-[0.07]"
        style={{ transform: "rotate(-30deg)" }}
      >
        {tiles.map((_, i) => (
          <span key={i} className="text-white text-[11px] whitespace-nowrap font-mono tracking-tight">
            {label}
          </span>
        ))}
      </div>
    </div>
  );
}
